/* @jsx jsx */
import { jsx } from '@emotion/react';
import { useIntl } from 'react-intl-next';
import Tag, { SimpleTag } from '@atlaskit/tag';
import messages from './messages';
import { cssVars, refinementTagStyles } from './styles';
/**
 * RefinementTag is the component which renders the
 * title of preset prompts such as
 * - Brainstorm
 * - Summarize
 *
 * When rendered as part of a user input field, it should provide an
 * onClick to display the remove button to allow users to remove the tag.
 * When rendered as a presentational element to show which
 * preset prompt has been used, it should not provide an onClick
 * to keep the tag presentational.
 */
export const RefinementTag = ({
  label,
  onClick,
  elemBefore,
  appearance
}) => {
  const styles = {
    [cssVars.alignItems]: appearance === 'rounded' ? 'center' : 'flex-start',
    [cssVars.elemBeforeHeight]: appearance === 'rounded' ? '100%' : 'auto'
  };
  const {
    formatMessage
  } = useIntl();
  return jsx("span", {
    style: styles,
    css: refinementTagStyles
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    ,
    className: "refinement-tag",
    "data-testid": "command-palette-refinement-tag",
    role: "status",
    "aria-atomic": "true",
    "aria-label": formatMessage(messages.promptSelected, {
      promptName: label
    }),
    "aria-live": "assertive"
  }, !onClick ? jsx(SimpleTag, {
    testId: 'refinement-tag',
    text: label
  }) : jsx(Tag, {
    appearance: appearance,
    elemBefore: elemBefore,
    testId: 'refinement-tag',
    removeButtonLabel: formatMessage(messages.removeLabel),
    text: label,
    onBeforeRemoveAction: () => {
      onClick();
      return false;
    }
  }));
};